import React, { useContext, useEffect } from 'react';
import { UNSAFE_DataRouterContext, useBlocker } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
export function EditorConfirm({ title, message, confirm, en, onCancel, onConfirm }) {
  const id = React.useId();
  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      className="pp-review-dialog"
      onClose={onCancel}
      aria-labelledby={id}
    >
      <DialogTitle id={id}>{title}</DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onCancel}>
          {en ? 'Keep editing' : '계속 편집'}
        </Button>
        <Button onClick={onConfirm}>{confirm || (en ? 'Leave' : '나가기')}</Button>
      </DialogActions>
    </Dialog>
  );
}
function RouterGuard({ state, en }) {
  const blocker = useBlocker(
    () => !state.current.released && (state.current.dirty || state.current.busy),
  );
  useEffect(() => {
    if (blocker.state === 'blocked' && state.current.busy) blocker.reset();
  }, [blocker, state]);
  return blocker.state === 'blocked' && !state.current.busy ? (
    <EditorConfirm
      en={en}
      title={en ? 'Cancel editing?' : '편집을 취소할까요?'}
      message={en ? 'Unsaved changes will be lost.' : '저장하지 않은 변경 내용은 사라집니다.'}
      onCancel={() => blocker.reset()}
      onConfirm={() => {
        state.current.released = true;
        blocker.proceed();
      }}
    />
  ) : null;
}
export default function PlaylistEditorGuard({ state, en }) {
  const router = useContext(UNSAFE_DataRouterContext);
  useEffect(() => {
    const guard = (e) => {
      if (!state.current.released && (state.current.dirty || state.current.busy)) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', guard);
    return () => window.removeEventListener('beforeunload', guard);
  }, [state]);
  return router ? <RouterGuard state={state} en={en} /> : null;
}
